// Ícone por seção do menu.
// Regra: seções conhecidas têm ícone fixo; as que vêm do banco (categorias de
// dashboard, nomes dinâmicos) recebem ícones DISTINTOS de uma paleta — duas
// seções nunca podem exibir o mesmo ícone.
const SECTION_ICONS: Record<string, string> = {
  ferramentas: '/media/icons/duotune/general/gen019.svg',
  'copiloto do vendedor': '/media/icons/duotune/communication/com007.svg',
  lojistas: '/media/icons/duotune/ecommerce/ecm004.svg',
  'super admin': '/media/icons/duotune/general/gen026.svg',
  gerencial: '/media/icons/duotune/graphs/gra010.svg',
}

// Paleta para seções não mapeadas — visualmente bem diferentes entre si.
const PALETA = [
  '/media/icons/duotune/graphs/gra001.svg',
  '/media/icons/duotune/graphs/gra007.svg',
  '/media/icons/duotune/finance/fin001.svg',
  '/media/icons/duotune/abstract/abs026.svg',
  '/media/icons/duotune/ecommerce/ecm008.svg',
  '/media/icons/duotune/general/gen032.svg',
  '/media/icons/duotune/graphs/gra004.svg',
  '/media/icons/duotune/technology/teh004.svg',
  '/media/icons/duotune/files/fil024.svg',
  '/media/icons/duotune/maps/map008.svg',
]

export const HOME_ICON = '/media/icons/duotune/general/gen001.svg'

const chave = (label: string) => label.trim().toLowerCase()

// Recebe TODAS as seções de uma vez para poder garantir unicidade.
export const mapearIconesDeSecoes = (labels: string[]): Record<string, string> => {
  const usados = new Set<string>()
  const mapa: Record<string, string> = {}

  // 1ª passada: os ícones fixos das seções conhecidas
  labels.forEach((label) => {
    const fixo = SECTION_ICONS[chave(label)]
    if (fixo && !usados.has(fixo)) {
      mapa[label] = fixo
      usados.add(fixo)
    }
  })

  // 2ª passada: as demais recebem o próximo ícone livre da paleta
  let proximo = 0
  labels.forEach((label) => {
    if (mapa[label]) return
    while (proximo < PALETA.length && usados.has(PALETA[proximo])) proximo++
    const icone = PALETA[proximo] ?? PALETA[Object.keys(mapa).length % PALETA.length]
    mapa[label] = icone
    usados.add(icone)
    proximo++
  })

  return mapa
}
